import { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

export default function ChatBubble() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: "bot", text: "👋 Hello! How can I help you today?" },
  ]);
  const [input, setInput] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  // ✅ Show popup only on first visit
  useEffect(() => {
    const seenPopup = localStorage.getItem("seenChatPopup");
    if (!seenPopup) {
      setShowPopup(true);
      localStorage.setItem("seenChatPopup", "true");
      setTimeout(() => {
        setShowPopup(false);
      }, 5000);
    }
  }, []);

const sendMessage = async () => {
  if (!input.trim()) return;

  const userMessage = { from: "user", text: input };
  setMessages((prev) => [...prev, userMessage]);
  setInput("");
    const token = localStorage.getItem("token")
  try {
    // 🌐 Send the user's message to your n8n webhook
    const response = await fetch("https://n8n.srv1004057.hstgr.cloud/webhook/helpChat", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: input,
        token: token,
        timestamp: new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to reach n8n webhook");
    }

    const data = await response.json();

    // 🧠 Add bot reply (from n8n response)
    setMessages((prev) => [
      ...prev,
      { from: "bot", text: data.output || "🤖 No response received from the AI." },
    ]);
  } catch (error) {
    console.error(error);
    setMessages((prev) => [
      ...prev,
      { from: "bot", text: "⚠️ Error connecting to the assistant. Please try again." },
    ]);
  }
};


  return (
    <>
      {/* ✅ Popup greeting message */}
      {showPopup && (
        <div className="fixed bottom-24 right-20 bg-white text-gray-800 shadow-lg border border-gray-200 rounded-xl px-4 py-3 text-sm max-w-[250px] animate-fade-in z-50">
          💬 Hi there! Need any help? Our AI assistant is here for you.
        </div>
      )}

      {/* ✅ Chat window */}
      {open && (
        <div className="fixed bottom-24 right-6 w-80 max-h-[70vh] bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col z-50 animate-slide-up">
          {/* Header */}
          <div className="bg-primary text-cream flex items-center justify-between px-4 py-2 rounded-t-2xl">
            <h3 className="font-semibold text-sm">Zuccess Assistant</h3>
            <button onClick={() => setOpen(false)}>
              <X size={18} />
            </button>
          </div>

          {/* Messages */}
          <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3 scroll-smooth">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`flex ${
                  msg.from === "user" ? "justify-end" : "justify-start"
                }`}
              >
                <div
                  className={`px-3 py-2 rounded-2xl max-w-[75%] text-sm ${
                    msg.from === "user"
                      ? "bg-accent text-white rounded-br-none"
                      : "bg-gray-100 text-gray-800 rounded-bl-none"
                  }`}
                >
                  {msg.text}
                </div>
              </div>
            ))}
          </div>

          {/* Input */}
          <div className="flex items-center border-t px-3 py-2 bg-white">
            <input
              type="text"
              className="flex-1 border rounded-full px-3 py-1 text-sm outline-none focus:ring-2 focus:ring-accent/40"
              placeholder="Type your message..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            />
            <button
              onClick={sendMessage}
              className="ml-2 text-accent font-semibold hover:text-accent/80"
            >
              Send
            </button>
          </div>
        </div>
      )}

      {/* ✅ Chat bubble button */}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 bg-accent text-white p-4 rounded-full shadow-lg hover:scale-105 transition-transform z-50"
      >
        <MessageCircle size={28} />
      </button>
    </>
  );
}
